import { brandingToThemeVars } from "../theme/brandingToThemeVars";
import { defaultSteps } from "../steps/registry";
const ALL_FREQUENCIES = ["OneOff", "Monthly", "Annual"];
const BANNER_IMAGE_POSITIONS = ["Left", "Center", "Right"];
const toBannerImagePosition = (value) => BANNER_IMAGE_POSITIONS.includes(value)
    ? value
    : "Center";
const FORM_POSITIONS = ["FullWidth", "Left", "Center", "Right"];
const toFormPosition = (value) => FORM_POSITIONS.includes(value) ? value : "FullWidth";
const byOrder = (a, b) => a.displayOrder - b.displayOrder;
export function documentToConfig(doc, opts = {}) {
    const frequencies = [...doc.allowedFrequencies].sort(byOrder);
    const defaultFrequency = (frequencies.find((f) => f.isDefault) ?? frequencies[0])?.frequency ?? "OneOff";
    const presetsByFrequency = ALL_FREQUENCIES.reduce((acc, freq) => {
        acc[freq] = doc.amountPresets
            .filter((p) => p.isActive && p.frequency === freq)
            .sort(byOrder);
        return acc;
    }, {});
    const messagesByType = doc.messages
        .filter((m) => m.isActive)
        .reduce((acc, m) => {
        acc[m.type] = m;
        return acc;
    }, {});
    const projects = doc.projects.filter((p) => p.isActive).sort(byOrder);
    const supportedLocales = doc.supportedLocales.length
        ? doc.supportedLocales
        : [doc.defaultLocale];
    return {
        document: doc,
        defaultCurrency: doc.defaultCurrency,
        supportedLocales,
        defaultLocale: doc.defaultLocale,
        themeVars: brandingToThemeVars(doc.branding),
        bannerImageUrl: doc.branding.bannerImageUrl,
        bannerImagePosition: toBannerImagePosition(doc.branding.bannerImagePosition),
        formPosition: toFormPosition(doc.branding.formPosition),
        frequencies,
        defaultFrequency,
        presetsByFrequency,
        messagesByType,
        projects,
        previewMode: opts.previewMode ?? false,
        steps: defaultSteps,
    };
}
